import React, { Component } from 'react';
import equal from 'deep-equal';

/** *
 * this class makes these assumptions:
 *
 * 1) the render should depend on a version of the props that is extrapolated into state.
 * 2) it's more efficient to have a componentShouldUpdate even if componentDidUpdate forces a second pass.
 *
 */
export default class PropsToStateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = this.propsToState(props);
  }

  propsToState(pProps) {
    const props = pProps || this.props;
    return { ...props };
  }

  shouldComponentUpdate(newProps, newState) {
    return !equal(this.state, newState) || !equal(newState, this.propsToState(newProps)); // not sure about part 2
  }

  componentDidUpdate() {
    if (!equal(this.state, this.propsToState())) {
      this.setState(this.propsToState());
    }
  }

  render() {
    console.log('override PTSC render: ', this.state, this);
    try {
      return <div><pre>{JSON.stringify(this.state)}</pre></div>;
    } catch (err) {
      try {
        return <div>{this.state}</div>;
      } catch (err2) {
        return <div>PTSC with un-renderable state</div>;
      }
    }
  }
}
